// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"bff40540","239":"9933c1fd","319":"99dbab33","389":"0245d082","732":"e1d857a6","977":"31abd38f"}[chunkId] + ".chunk.js";
};